export enum PGlobalMenuItemKeys {
  RESERVATION_CALENDAR = 'reservation-calendar',
  RESERVATION_GRID = 'reservation-grid',
  DASHBOARD = 'dashboard',
  GUESTS_GROUP = 'guests-group',
  OFFERS = 'offers',
  GUESTS_DATABASE = 'guests-database',
  CONTACT_PERSONS = 'contact-persons',
  FOREIGN_GUEST_REGISTER = 'foreign-guest-register',
  GUEST_BOOK = 'guest-book',
  COMPANIES = 'companies',
  MAILING = 'mailing',
  MAILING_AUTOMATED = 'mailing-automated',
  MAILING_MARKETING = 'mailing-marketing',
  COMMUNICATION = 'communication',
  LOYALTY_PROGRAMME = 'loyalty-programme',
  LOYALTY_PROGRAMME_CARDS = 'loyalty-programme-cards',
  LOYALTY_PROGRAMME_POINTS = 'loyalty-programme-points',
  PAYMENTS_GROUP = 'payments-group',
  ACCOUNTING_DOCUMENTS = 'accounting-documents',
  GIFT_VOUCHERS = 'gift-vouchers',
  FOLIOS = 'folios',
  PAYMENTS = 'payments',
  PAYMENTS_CASHBOOK = 'payments-cashbook',
  PAYMENTS_BANK_TRANSFERS = 'payments-bank-transfers',
  PAYMENTS_PAYMENT_TERMINAL = 'payments-payment-terminal',
  PAYMENTS_ONLINE_PAYMENTS = 'payments-online-payments',
  PAYMENTS_COUPONS = 'payments-coupons',
  STOCK_TRANSACTIONS = 'stock-transactions',
  CLOSURE = 'closure',
  EXCHANGE_OFFICE = 'exchange-office',
  CODEBOOKS = 'codebooks',
  ACCOUNT_ASSIGNMENT = 'account-assignment',
  VAT_BREAKDOWN = 'vat-breakdown',
  PKWIU = 'pkwiu',
  GTU_CODES = 'gtu-codes',
  REPORTS_GROUP = 'reports-group',
  USER_ACTIVITY = 'user-activity',
  STATISTICS_REPORTS = 'statistics-reports',
  DAILY_OVERVIEW = 'daily-overview',
  REPORTS_VISITOR_TAX = 'reports-visitor-tax',
  REVIEWS = 'reviews',
  COMMISSIONS = 'commissions',
  NTAK_GROUP = 'ntak-group',
  NTAK_REPORTS = 'ntak-reports',
  NTAK_REVENUES = 'ntak-revenues',
  NTAK_EXPENSES = 'ntak-expenses',
  NTAK_CONNECTION = 'ntak-connection',
  VISA_GROUP = 'visa-group',
  VISA_STATISTICS = 'visa-statistics',
  MANAGER_REPORTS_GROUP = 'manager-reports-group',
  MANAGER_REPORTS_DASHBOARD = 'manager-reports-dashboard',
  MANAGER_REPORTS_ALFRED = 'manager-reports-alfred',
  MANAGER_REPORTS_OCCUPANCY = 'manager-reports-occupancy',
  MANAGER_REPORTS_RESERVATION = 'manager-reports-reservation',
  MANAGER_REPORTS_PICK_UP_REPORT = 'manager-reports-pick-up-report',
  MANAGER_REPORTS_FINANCE = 'manager-reports-finance',
  MANAGER_REPORTS_OVERVIEW = 'manager-reports-overview',
  MANAGER_REPORTS_HOTEL_GROUP_OVERVIEW = 'manager-reports-hotel-group-overview',
  MANAGER_REPORTS_NTAK_KPI = 'manager-reports-ntak-kpi',
  PRICES_GROUP = 'prices-group',
  PRICE_LIST = 'price-list',
  MEALS_LIST = 'meals-list',
  REVENUE_MANAGEMENT = 'revenue-management',
  PRICES_EXCHANGE_RATES = 'prices-exchange-rates',
  PRICES_VISITOR_TAX = 'prices-visitor-tax',
  DISCOUNTS_GROUP = 'discounts-group',
  DISCOUNT_LONG_TERM = 'discount-long-term',
  DISCOUNT_FIRST_MINUTE = 'discount-first-minute',
  DISCOUNT_LAST_MINUTE = 'discount-last-minute',
  DISCOUNT_SPECIAL_PRICE = 'discount-special-price',
  DISCOUNT_COUPONS = 'discount-coupons',
  SERVICES = 'services',
  STOCK_ITEMS = 'stock-items',
  STAY_PACKAGES = 'stay-packages',
  SETTINGS_GROUP = 'settings-group',
  SETTINGS_HOTEL_GROUP = 'settings-hotel-group',
  HOTEL_GENERAL_SETTINGS = 'hotel-general-settings',
  HOTEL_AMENITIES = 'hotel-amenities',
  HOTEL_PHOTO_GALLERIES = 'hotel-photo-galleries',
  HOTEL_GUEST_CATEGORIES = 'hotel-guest-categories',
  HOTEL_ROOMS = 'hotel-rooms',
  HOTEL_CONNECTORS = 'hotel-connectors',
  ONLINE_RESERVATIONS_GROUP = 'online-reservations-group',
  BOOKING_SETTINGS = 'booking-settings',
  PAYMENTS_SETTINGS = 'payments-settings',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  PRIVACY_POLICY = 'privacy-policy',
  MY_CONNECTIONS = 'my-connections',
  SERVICE_MAPPING = 'service-mapping',
  MARKETPLACE = 'marketplace',
  WEB_GROUP = 'web-group',
  WEB_GENERAL = 'web-general',
  WEB_SECTIONS = 'web-sections',
  WEB_NEWS = 'web-news',
  UPDATE_WP_DATA = 'update-wp-data',
  LOGIN_WP_ADMIN = 'login-wp-admin',
  APP_GROUP = 'app-group',
  ALFRED_APP_SETTINGS = 'alfred-app-settings',
  SELF_SERVICE_BAR_APP_SETTINGS = 'self-service-bar-app-settings',
  LOCK_SYSTEMS_SETTINGS = 'lock-systems-settings',
  POS_APP_SETTINGS = 'pos-app-settings',
  CONNECTED_ROOMS_APP_SETTINGS = 'connected-rooms-app-settings',
  USERS_GROUP = 'users-group',
  ROLES_SETTINGS = 'roles-settings',
  USERS_SETTINGS = 'users-settings',
  DESCRIPTIONS = 'descriptions',
  MARKET_CODES = 'market-codes',
  SIGNIFICANT_DATES = 'significant-dates',
  SYSTEM_SETTINGS_GROUP = 'system-settings-group',
  SYSTEM_SETTINGS_RESERVATION = 'system-settings-reservation',
  SYSTEM_SETTINGS_VOUCHER = 'system-settings-voucher',
  SYSTEM_SETTINGS_FOLIO = 'system-settings-folio',
  SYSTEM_SETTINGS_REPORTS = 'system-settings-reports',
  SYSTEM_SETTINGS_EMAIL = 'system-settings-email',
  NOTIFICATION_SETTINGS = 'notification-settings',
  NOTIFICATION_SETTINGS_RESERVATION = 'notification-settings-reservation',
  HOUSEKEEPING_GROUP = 'housekeeping-group',
  CLEANING = 'cleaning',
  DEFECTS = 'defects',
  TASKS = 'tasks',
  TASK_TEMPLATES = 'task-templates',
  HELP_GROUP = 'help-group',
  HELP_INVOICES = 'help-invoices',
  HELP_MANUAL = 'help-manual',
  HELP_USER_TIPS = 'help-user-tips',
  HELP_FEEDBACK = 'help-feedback',
  HELP_DEMO = 'help-demo',
}

export type PGlobalMenuIcon = string | null

export class PGlobalMenuItem {
  constructor(
    public key: PGlobalMenuItemKeys | string,
    public title: string,
    public icon: PGlobalMenuIcon,
    public route: string,
    public isVisible: boolean = true,
    public isPromoted: boolean = false,
  ) {}
}

export class PGlobalMenuWithSubMenu {
  constructor(
    public key: PGlobalMenuItemKeys | string,
    public title: string,
    public icon: PGlobalMenuIcon,
    public items: (PGlobalMenuWithSubMenu | PGlobalMenuItem)[],
    public isVisible: boolean | null = null,
    public isPromoted: boolean = false,
  ) {
    this.isVisible ??= items.some((item) => item.isVisible)
  }
}
